import { useEffect, useMemo } from 'react';

import { FileConfig, Rotate, ConfigFlags as FileConfigFlags } from 'services/file.service';
import { useResizeObserver } from 'hooks/use-resize-observer';
import { ConfigFlags as ClipConfigFlags } from 'services/clip.service';
import { useAppDispatch } from 'store/store-hooks';

import { Clip, setPanZoomRotateListener } from 'components/app/editor/_mediator/editor.slice';

export const useCssRotate = (
  el: React.RefObject<HTMLDivElement>,
  payload: {
    fileConfig?: FileConfig;
    clipData?: Clip;
    rotate?: Rotate | null;
    flip?: boolean;
  },
  rotateListener?: boolean
) => {
  const { clipData, fileConfig, rotate, flip } = payload;
  const dispatch = useAppDispatch();

  const data = useMemo(() => {
    return {
      rotate: rotate || (clipData?.config.rotate ?? fileConfig?.rotate) || Rotate.default,
      flip: !!(
        flip ||
        (clipData?.config.flags.includes(ClipConfigFlags.flip) ?? false) !==
          (fileConfig?.flags.includes(FileConfigFlags.flip) ?? false)
      ),
    };
  }, [clipData, fileConfig, rotate, flip]);

  const handleStyles = () => {
    if (data.rotate === Rotate.d90 || data.rotate === Rotate.d270) {
      el.current?.style.setProperty('max-width', `${el.current?.clientHeight}px`);
      el.current?.style.setProperty('margin', '0 auto');
    } else {
      el.current?.style.setProperty('max-width', '100%');
    }
  };

  useResizeObserver(el, handleStyles);

  useEffect(() => {
    el.current?.style.setProperty('transform', `rotate(${data.rotate * 90}deg)${data.flip ? 'scaleY(-1)' : ''}`);
    handleStyles();
    if (rotateListener) dispatch(setPanZoomRotateListener({ rotate: data.rotate, flip: data.flip }));
  }, [data.rotate, data.flip]);

  return data;
};
